export const getAddressesSelected = (state) => state.addresses.selected
